// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type ChatFileDownloadQueryVariables = Types.Exact<{
  fileId: Types.Scalars['ID']['input'];
}>;


export type ChatFileDownloadQuery = { __typename?: 'Query', chatFileDownload: { __typename?: 'ChatFileDownload', url: string, fileName: string, expiresAt: any } };


export const ChatFileDownloadDocument = gql`
    query ChatFileDownload($fileId: ID!) {
  chatFileDownload(fileId: $fileId) {
    url
    fileName
    expiresAt
  }
}
    `;

/**
 * __useChatFileDownloadQuery__
 *
 * To run a query within a React component, call `useChatFileDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatFileDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatFileDownloadQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useChatFileDownloadQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatFileDownloadQuery, ChatFileDownloadQueryVariables> & ({ variables: ChatFileDownloadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>(ChatFileDownloadDocument, options);
      }
export function useChatFileDownloadLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>(ChatFileDownloadDocument, options);
        }
// @ts-ignore
export function useChatFileDownloadSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>;
export function useChatFileDownloadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatFileDownloadQuery | undefined, ChatFileDownloadQueryVariables>;
export function useChatFileDownloadSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>(ChatFileDownloadDocument, options);
        }
export type ChatFileDownloadQueryHookResult = ReturnType<typeof useChatFileDownloadQuery>;
export type ChatFileDownloadLazyQueryHookResult = ReturnType<typeof useChatFileDownloadLazyQuery>;
export type ChatFileDownloadSuspenseQueryHookResult = ReturnType<typeof useChatFileDownloadSuspenseQuery>;
export type ChatFileDownloadQueryResult = ApolloReactCommon.QueryResult<ChatFileDownloadQuery, ChatFileDownloadQueryVariables>;